import { checkShouldRedirectLinkForSeo, isGlobalSite } from '@/lib/checkService'

const isRegionNewRoute = checkShouldRedirectLinkForSeo()
const pricingNew = isGlobalSite() ? 'shopping/pricing' : 'shipping/pricing'
const shippingNew = isGlobalSite() ? 'shopping' : 'shipping'
const protectionShippingNew = isGlobalSite()
	? 'shopping/protection'
	: 'shipping/protection'
const tutorialNew = isGlobalSite() ? 'shopping/tutorial' : 'shipping/tutorial'
const restrictionsNew = isGlobalSite()
	? 'restrictions'
	: 'shipping/restrictions'

// https://buyandship.sg.larksuite.com/wiki/EzMrwEBJjifx6PkdW74lN2PZgTh#share-J3XcdTTMOoLLUwxH634lamhzgqe
const mapping = {
	shipping: isRegionNewRoute ? shippingNew : 'shipping',
	proxyShopping: isRegionNewRoute ? 'shopping' : 'features/proxy-shopping',
	pricing: isRegionNewRoute ? pricingNew : 'pricing',
	redemption: isRegionNewRoute
		? 'shipping/redemption-centres'
		: 'redemption-centres',
	protectionShipping: isRegionNewRoute
		? protectionShippingNew
		: 'protection/shipping',
	protectionShopping: isRegionNewRoute
		? 'shopping/protection'
		: 'protection/shopping',
	warehouses: isRegionNewRoute ? 'shipping/warehouses' : 'warehouses',
	tutorial: isRegionNewRoute ? tutorialNew : 'tutorial',
	restrictions: isRegionNewRoute ? restrictionsNew : 'restrictions',
}

/**
 * Returns the SEO-friendly path for the given route.
 * @param {keyof typeof mapping} route - The route name (must be a key of the mapping object)
 * @returns {string} The corresponding SEO-friendly path
 */
export default function getRedirectSeoLink(
	route: keyof typeof mapping,
): string {
	return mapping[route]
}
